<template>
  <div>
    <div class="mainContainer" v-if="loaded">
      <h1 class="titleText editableText">
        {{ editingTitle ? "" : surveydata.title }}
        <input
          type="text"
          v-if="editingTitle"
          :value="surveydata.title"
          id="titleInput"
        />
        <EditButton :isEditing="editingTitle" @click="editTitle()" />
      </h1>

      <h4 class="codeText editableText">
        Code: {{ editingCode ? "" : $route.params.code }}
        <input
          type="text"
          v-if="editingCode"
          :value="$route.params.code"
          id="codeInput"
        />
        <EditButton :isEditing="editingCode" @click="editCode()" />
      </h4>

      <div v-for="(q, index) in surveydata.questions" :key="q.id">
        <Question
          :text="q.text"
          :scale="q.scale"
          :id="q.id"
          :deselectable="q.deselectable"
          :isfirst="index === 0"
          :categoryData="categoryData"
          :categoryId="q.categoryId"
        />
      </div>

      <div>
        <button @click="addQuestion()" style="margin-top: 0.5rem">
          <h2>Add question</h2>
        </button>
        <button
          @click="this.$router.push('/manage')"
          style="
            background-color: #28a745;
            margin-left: 1rem;
            margin-top: 0.5rem;
          "
        >
          <h2>Done</h2>
        </button>
      </div>

      <div style="margin: 0; display: flex; justify-content: center">
        <div
          style="
            margin-top: 6rem;
            border: 1px solid #fff;
            padding: 1rem 3rem;
            border-radius: 1rem;
            width: max-content;
          "
        >
          <h2>
            Categories
            <div class="lds-ring" v-if="loadCategory">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </h2>
          <div
            style="
              padding-bottom: 0.8rem;
              margin-left: 1rem;
              margin-right: 1rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: max-content;
            "
            v-for="(categoryName, id) in categoryData"
            :key="id"
          >
            <input
              type="text"
              placeholder="Category Name"
              style="width: 300px"
              :value="categoryName"
              @input="
                (e) => {
                  categoryChanged(id, e);
                }
              "
              :ref="'caterogyInput' + id"
            />

            <button
              class="deleteButton"
              :style="{
                color: '#fff',
                opacity: id == '0' ? '0.4' : '1',
                cursor: id == '0' ? 'not-allowed' : 'pointer',
              }"
              @click="
                () => {
                  deleteCategory(id);
                }
              "
              :disabled="id == '0'"
            >
              <span class="material-symbols-outlined"> delete_forever </span>
            </button>
          </div>

          <div
            style="
              padding-bottom: 0.8rem;
              margin-left: 1rem;
              margin-right: 1rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: max-content;
            "
          >
            <input
              type="text"
              placeholder="Type to add category"
              style="width: 300px"
              @input="
                (e) => {
                  newCategory(nextCategoryId, e);
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseurl } from "../api";
import EditorQuestion from "./EditorQuestion.vue";
import pointsStore from "../pointsStore";
import EditButton from "./EditButton.vue";
import accountStore from "../accountStore";
import _ from "lodash";

let doRefocusOn = "";
export default {
  name: "Edit",
  components: {
    Question: EditorQuestion,
    EditButton: EditButton,
  },
  computed: {
    nextCategoryId() {
      return (
        Math.max(...Object.keys(this.categoryData).map((n) => parseInt(n))) + 1
      );
    },
  },
  updated() {
    if (doRefocusOn != "") {
      this.$refs[doRefocusOn][0].focus();
      doRefocusOn = "";
    }
  },
  watch: {
    categoryData: {
      handler() {
        this.loadCategory = true;
        this.debouncedCategoryUpdate(this);
      },
      deep: true,
    },
  },
  methods: {
    debouncedCategoryUpdate: _.debounce((th) => {
      axios
        .post(baseurl + "editcategories", {
          surveyCode: th.$route.params.code,
          jsonData: JSON.stringify(th.categoryData),
          p: accountStore.passcode,
        })
        .then((r) => {
          if (r.data.success) {
            th.loadCategory = false;
          }
        });
    }, 500),
    newCategory(id, e) {
      this.categoryData[id] = e.target.value;
      e.target.value = "";
      doRefocusOn = "caterogyInput" + id;
    },
    categoryChanged(id, e) {
      this.categoryData[id] = e.target.value;
    },
    deleteCategory(id) {
      if (id != "0") {
        delete this.categoryData[id];
        axios.post(baseurl + "editcategories", {
          surveyCode: this.$route.params.code,
          jsonData: JSON.stringify(this.categoryData),
          p: accountStore.passcode,
        });
        axios
          .post(baseurl + "deletecategory", {
            surveyCode: this.$route.params.code,
            categoryId: id,
            p: accountStore.passcode,
          })
          .then((r) => {
            if (r.data.success) {
              this.fetchSurvey();
            }
          });
      }
    },
    editTitle() {
      if (this.editingTitle) {
        axios
          .post(baseurl + "editsurveytitle", {
            code: this.$route.params.code,
            title: document.getElementById("titleInput").value,
            p: accountStore.passcode,
          })
          .then((r) => {
            if (r.data.success) {
              this.fetchSurvey();
            }
          });
      }
      this.editingTitle = !this.editingTitle;
    },
    editCode() {
      if (this.editingCode) {
        const newCode = document.getElementById("codeInput").value;
        axios
          .post(baseurl + "editsurveycode", {
            code: this.$route.params.code,
            newCode,
            p: accountStore.passcode,
          })
          .then((r) => {
            if (r.data.success) {
              this.$router.push("/edit/" + newCode);
            }
          });
      }
      this.editingCode = !this.editingCode;
    },
    addQuestion() {
      axios
        .post(baseurl + "createquestion", {
          code: this.$route.params.code,
          p: accountStore.passcode,
        })
        .then((r) => {
          if (r.data.success) {
            this.fetchSurvey();
          }
        });
    },
    fetchSurvey() {
      axios
        .get(baseurl + "getsurvey", {
          params: { code: this.$route.params.code },
        })
        .then((r) => {
          if ("success" in r.data && r.data.success === false) {
            this.$router.push("/");
            return;
          }
          this.loaded = true;
          this.surveydata = r.data;
          this.categoryData = JSON.parse(r.data.categoryData);
        })
        .catch(() => {
          this.$router.push("/");
        });
      pointsStore.resetStore();
    },
  },
  data() {
    return {
      loaded: false,
      showLoading: false,
      surveydata: {},
      editingTitle: false,
      editingCode: false,
      categoryData: {},
      loadCategory: false,
    };
  },
  mounted() {
    if (!accountStore.verified) {
      this.$router.push("/admin");
    }
    this.fetchSurvey();
  },
};
</script>

<style scoped>
.editableText {
  display: flex;
  align-items: center;
}

input {
  border: 1px solid #555555;
  border-radius: 1rem;
  padding: 0.5rem 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  height: 100%;
}

.titleText,
.codeText {
  text-align: left;
  margin-left: 2rem;
}

.titleText {
  margin-bottom: 0;
}

.codeText {
  margin: 0.5rem inherit;
}

.mainContainer {
  max-width: 800px;
  padding-bottom: 2rem;
}

button {
  background-color: #007bff;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  margin-top: 2rem;
}

button > h2 {
  color: #ffffff;
  margin: 0.7rem 1rem 0.7rem 1rem;
}

.delayshow {
  transition: 300ms;
}

.doshow {
  opacity: 1;
}

.dohide {
  opacity: 0;
}

.deleteButton {
  border: none;
  border-radius: 9999px !important;
  cursor: pointer;
  color: #ffffff;
  background-color: rgb(220, 53, 69);
  margin: 0 !important;
  margin-left: 0.5rem !important;
  padding: 0.3rem 0.4rem;
  display: inline-block;
  transition: 300ms;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 22px;
  height: 22px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  margin: 3px;
  border: 3px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
